import * as React from 'react';

import ArticlesRecommendationsModuleNotConfigurable from 'bundles/unified-description-page-common/components/recommendations/ArticlesRecommendationsModuleNotConfigurable';
import { useArticlesRecommendations } from 'bundles/unified-description-page-common/contexts/consumer/ArticlesRecommendationsContext';
import type { ConsumerCoursePageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerCoursePageQuery';
import type { ConsumerSpecializationPageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerSpecializationPageQuery';
import getProductTitle from 'bundles/unified-description-page-common/utils/getProductTitle';

import _t from 'i18n!nls/xdp';

type PageData = ConsumerSpecializationPageFieldsFragment | ConsumerCoursePageFieldsFragment;

type Props = {
  pageData: Pick<PageData, 'name' | 'domains' | 'slug'> & {
    productVariant?: ConsumerSpecializationPageFieldsFragment['productVariant'];
  };
};

const ArticlesRecommendationsModuleRenderer = ({ pageData }: Props) => {
  const articlesRecommendations = useArticlesRecommendations();
  const productTitle = getProductTitle(pageData.name, pageData.productVariant);

  return (
    <ArticlesRecommendationsModuleNotConfigurable
      recommendations={articlesRecommendations?.recommendations}
      isRecommendationsLoading={!!articlesRecommendations?.isArticlesRecsLoading}
      title={_t('New to #{subdomainOrDomainName}? Start here.', {
        subdomainOrDomainName: pageData.domains?.[0]?.subdomainName || pageData.domains?.[0]?.domainName,
      })}
      trackingData={{ slug: pageData.slug, productTitle }}
    />
  );
};

export default ArticlesRecommendationsModuleRenderer;
